// 编辑器自定义事件
const events = {
    
}

const mixins = {
    methods: events,
}

export const eventData = [
    { key: 'publish', label: '发布' },
    { key: 'publishTopic', label: '发布主题' },
    { key: 'publishPayload', label: '发布内容' },
    { key: 'publishComponents', label: '关联发布组件ID' },
    { key: 'subscribe', label: '订阅' },
    { key: 'subscribeTopic', label: '订阅主题' },
    { key: 'example', label: '数据示例' },
]

export {
    mixins,
    events,
}